import React, { Fragment } from 'react';
import { IFrame } from '@klp/iframe';

import { Main } from '@klp/layout';
import { useTranslation } from 'react-i18next';

import { LeverandorReportAccess, LeverandorReportUrl } from '../config';

import { useCurrentUser } from '@klp/auth';

export default function LeverandorReport() {
    const { t } = useTranslation();
    const { currentUser } = useCurrentUser();

    const filteredLeverandorReportLinkHandler = () => {
        const filteredLink = LeverandorReportUrl();

        return filteredLink;
    };

    return (
        <>
            <Main>
                <Main.Breadcrumbs>
                    <Main.Crumb
                        id="leverandor-report"
                        label={t('breadcrumbs.leverandor.leverandorReport')}
                    />
                </Main.Breadcrumbs>
                {LeverandorReportAccess(currentUser) && (
                    <IFrame src={filteredLeverandorReportLinkHandler()} />
                )}
            </Main>
        </>
    );
}
